export default __webpack_public_path__ + "static/media/jocimaraLobao.6d3c96a6.png";